<template>
  <div class="overseasDetail">
    <van-form
      label-width="100px"
      :show-error="false"
      :scroll-to-error="false"
      @submit="onSubmit"
    >
      <div class="title" v-if="OASId">{{ $t.supplier.editTitle }}</div>
      <div class="title" v-else>{{ $t.supplier.addTitle }}</div>

      <van-field
        v-model="form.CostRecordNumber"
        :label="$t.supplier.costRecord"
        label-class="number-label"
        disabled
        v-if="form.CostRecordNumber"
      >
        <template #button>
          <van-button
            size="small"
            type="info"
            @click="onCopy($event, form.CostRecordNumber)"
            native-type="button"
            v-if="form.CostRecordNumber"
            >{{ $t.meta.copy }}</van-button
          >
        </template>
      </van-field>

      <van-field
        v-model="form.Customer.text"
        :label="$t.supplier.shipperCompany"
        :placeholder="$t.meta.input"
        type="textarea"
        rows="3"
        @click="onShowEmit('showOverseasDetailCustomer')"
        clickable
        readonly
        required
        :rules="formRule"
      >
        <template #button>
          <van-button
            size="small"
            type="info"
            @click="onCopy($event, form.Customer.text)"
            native-type="button"
            v-if="form.Customer.value"
            >{{ $t.meta.copy }}</van-button
          >
        </template>
      </van-field>

      <van-field
        clickable
        readonly
        :value="form.RegionName"
        :label="$t.supplier.area"
        :placeholder="$t.meta.select"
        @click="onShowEmit('showWarehouseDetailArea')"
        required
        :rules="formRule"
      />

      <van-field
        clickable
        readonly
        :value="form.CountryName"
        :label="$t.meta.country"
        :placeholder="$t.meta.select"
        @click="onShowEmit('showWarehouseDetailCountry')"
        required
        :rules="formRule"
      />

      <van-field
        clickable
        readonly
        :value="form.CityName"
        :label="$t.meta.city"
        :placeholder="$t.meta.select"
        @click="onShowEmit('showWarehouseDetailCity')"
        required
        :rules="formRule"
      />

      <van-field
        clickable
        readonly
        :value="form.AWName"
        :label="$t.supplier.awWay"
        :placeholder="$t.meta.select"
        @click="onShowEmit('showWarehouseDetailAw')"
        required
        :rules="formRule"
      />

      <van-field
        clickable
        readonly
        :value="form.BCName"
        :label="$t.supplier.bcType"
        :placeholder="$t.meta.select"
        @click="onShowEmit('showWarehouseDetailBc')"
        required
        :rules="formRule"
      />

      <div class="multi-table" v-if="form.QuotationList">
        <van-field name="stepper" :label="$t.supplier.collection">
          <template #input>
            <van-stepper
              :min="1"
              :value="form.QuotationList.length"
              @minus="handleDel"
              @plus="handleAdd"
              :disable-input="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in form.QuotationList" :key="index">
          <div class="multi-table-header" v-if="index > 0">
            <div class="multi-table-title"></div>
            <div class="multi-table-btn" @click="handleDelByIndex(index)">
              <van-icon name="close" />
            </div>
          </div>
          <van-field
            v-model="item.LeavelName"
            :label="$t.supplier.section"
            @click="pickerShow(index, 'showLevelPicker')"
            :placeholder="$t.meta.select"
            type="textarea"
            rows="2"
            clickable
            readonly
          />
          <van-field
            v-model="item.Item"
            :label="$t.supplier.collection"
            :placeholder="$t.meta.input"
          />
          <van-field
            v-model="item.WeightBreak"
            :label="$t.supplier.sectionCharge"
            :placeholder="$t.meta.input"
          />
          <van-field
            v-model="item.DenistyRatio"
            :label="$t.supplier.denistyRatio"
            :placeholder="$t.meta.input"
          />
          <van-field
            v-model="item.CurrencySn"
            :label="$t.meta.currency"
            @click="pickerShow(index, 'showCurrencyPicker')"
            :placeholder="$t.meta.select"
            clickable
            readonly
          />
          <van-field
            v-model="item.Minimum"
            :label="$t.supplier.minimum"
            :placeholder="$t.meta.input"
            oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
          />
          <van-field
            v-model="item.MinimumChargeUnit"
            :label="$t.supplier.minimumUnit"
            :placeholder="$t.meta.input"
          />
          <van-field
            v-model="item.UnitPrice"
            :label="$t.supplier.unitPrice"
            :placeholder="$t.meta.input"
            oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
          />
          <van-field
            v-model="item.UnitPriceChargeUnit"
            :label="$t.supplier.unitPriceCharge"
            :placeholder="$t.meta.input"
          />
        </div>
      </div>

      <van-field
        v-model="form.CompanyName"
        :label="$t.supplier.companyName"
        :placeholder="$t.meta.input"
        type="textarea"
        rows="3"
      />

      <van-field
        v-model="form.Address"
        :label="$t.supplier.address"
        :placeholder="$t.meta.input"
        type="textarea"
        rows="3"
      />

      <van-field
        v-model="form.ContactPhone"
        :label="$t.supplier.contactPhone"
        :placeholder="$t.meta.input"
        type="textarea"
        rows="3"
      />

      <van-field
        v-model="form.Contact"
        :label="$t.supplier.contact"
        :placeholder="$t.meta.input"
        type="textarea"
        rows="3"
      />

      <van-field
        v-model="form.Email"
        :label="$t.supplier.email"
        :placeholder="$t.meta.input"
        type="textarea"
        rows="3"
      />

      <van-field
        v-model="form.OperationNotes"
        :label="$t.supplier.notes"
        :placeholder="$t.meta.input"
        type="textarea"
        rows="10"
      />

      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit">{{
          $t.meta.submit
        }}</van-button>
      </div>
    </van-form>

    <fetch-list
      event="showOverseasDetailCustomer"
      type="customerManagement"
      request="getCustomerInfoSearchList"
      @onSelect="onSelectCustomer"
    ></fetch-list>

    <option-list
      event="showWarehouseDetailArea"
      :options="areaList"
      @onSelect="onSelectArea"
    ></option-list>

    <option-list
      event="showWarehouseDetailCountry"
      :options="countryList"
      @onSelect="onSelectCountry"
    ></option-list>

    <option-list
      event="showWarehouseDetailCity"
      :options="cityList"
      @onSelect="onSelectCity"
    ></option-list>

    <option-list
      event="showWarehouseDetailAw"
      :options="awList"
      @onSelect="onSelectAw"
    ></option-list>

    <option-list
      event="showWarehouseDetailBc"
      :options="serviceList"
      @onSelect="onSelectBc"
    ></option-list>

    <van-popup v-model="showLevelPicker" round position="bottom">
      <van-picker
        :title="$t.supplier.section"
        show-toolbar
        :columns="leavelOptions"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="pickerConfirm($event, 'LeavelName', 'LeavelId')"
        @cancel="showLevelPicker = false"
      />
    </van-popup>

    <van-popup v-model="showCurrencyPicker" round position="bottom">
      <van-picker
        :title="$t.meta.currency"
        show-toolbar
        :columns="currencyList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="pickerConfirm($event, 'CurrencySn', 'Currency')"
        @cancel="showCurrencyPicker = false"
      />
    </van-popup>
  </div>
</template>
<script>
import Vue from "vue";
import FetchList from "@components/fetchList/FetchList.vue";
import OptionList from "@components/optionList/OptionList.vue";
import {
  Form,
  Field,
  Button,
  Icon,
  Image,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Popup,
  DatetimePicker,
  Switch,
  Uploader,
  Stepper,
  Picker,
} from "vant";

Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Icon)
  .use(Image)
  .use(Radio)
  .use(RadioGroup)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Popup)
  .use(DatetimePicker)
  .use(Switch)
  .use(Uploader)
  .use(Stepper)
  .use(Picker);

export default {
  name: "overseasDetail",
  components: {
    FetchList,
    OptionList,
  },
  data() {
    return {
      OASId: "",
      form: {
        CostRecordNumber: "",
        Customer: { value: "" },
        RegionName: "",
        RegionId: "",
        CountryName: "",
        CountryId: "",
        CityName: "",
        CityId: "",
        AWName: "",
        AWId: "",
        BCName: "",
        BCId: "",
        QuotationList: [],
        CompanyName: "",
        Address: "",
        ContactPhone: "",
        Contact: "",
        Email: "",
        OperationNotes: "",
      },
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
      currencyList: [],
      //选项
      settings: [],
      awList: [],
      serviceList: [],
      leavelOptions: [],
      areaList: [],
      countryList: [],
      cityList: [],
      //picker
      itemIndex: 0,
      showLevelPicker: false,
      showCurrencyPicker: false,
    };
  },
  created() {
    const { OASId } = this.$route.query;
    this.OASId = OASId;
    this.getCurrencyList();
    this.getOverseasAgentServiceSetting().then((success) => {
      if (success) {
        if (this.OASId) this.getOverseasAgentServiceDetail();
      }
    });
  },
  methods: {
    handleAdd() {
      this.form.QuotationList.push({
        LeavelName: "",
        LeavelId: "1",
        Item: "",
        WeightBreak: "",
        DenistyRatio: "",
        CurrencySn: "",
        Currency: null,
        Minimum: "",
        MinimumChargeUnit: "",
        UnitPrice: "",
        UnitPriceChargeUnit: "",
      });
    },
    handleDel() {
      this.form.QuotationList.pop();
    },
    handleDelByIndex(index) {
      if (this.form.QuotationList.length > 0) {
        this.form.QuotationList.splice(index, 1);
      }
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    getOverseasAgentServiceDetail() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          OASId: this.OASId,
        };
        this.$api.supplier
          .getOverseasAgentServiceDetail(param)
          .then((res) => {
            this.applyData(res.data);
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    applyData(data) {
      this.form.CostRecordNumber = data.CostRecordNumber;
      this.form.Customer = {
        text: data.CustomerCompanyName,
        value: data.CustomerId,
      };
      this.form.RegionId = data.RegionId;
      var region = this.areaList.find((c) => c.value == data.RegionId);
      if (region) {
        this.form.RegionName = region.text;
      }

      this.form.CountryId = data.CountryId;
      var country = this.countryList.find((c) => c.value == data.CountryId);
      if (country) {
        this.form.CountryName = country.text;
      }

      this.form.CityId = data.CityId;
      var city = this.cityList.find((c) => c.value == data.CityId);
      if (city) {
        this.form.CityName = city.text;
      }

      this.form.AWId = data.AWId;
      var aw = this.awList.find((c) => c.value == data.AWId);
      if (aw) {
        this.form.AWName = aw.text;
      }

      this.form.BCId = data.BCId;
      var bc = this.serviceList.find((c) => c.value == data.BCId);
      if (bc) {
        this.form.BCName = bc.text;
      }

      this.form.QuotationList = data.QuotationList;
      for (const quotationItem of this.form.QuotationList) {
        var leavel = this.leavelOptions.find((c) => c.value == quotationItem.LeavelId);
        if (leavel) {
          quotationItem.LeavelName = leavel.text;
        }
        var currency = this.currencyList.find((c) => c.value == quotationItem.Currency);
        if (currency) {
          quotationItem.CurrencySn = currency.text;
        }
      }

      this.form.CompanyName = data.CompanyName;
      this.form.Address = data.Address;
      this.form.ContactPhone = data.ContactPhone;
      this.form.Contact = data.Contact;
      this.form.Email = data.Email;
      this.form.OperationNotes = data.OperationNotes;
    },
    getOverseasAgentServiceSetting() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        this.$api.supplier
          .getOverseasAgentServiceSetting()
          .then((res) => {
            this.settings = res.data;

            var awList = [];
            this.settings[0].forEach((item) => {
              let data = {
                text: item.AWName,
                value: item.AWId,
              };
              awList.push(data);
            });
            this.awList = this.$commonMethod.deepClone(awList);

            var serviceList = [];
            this.settings[1].forEach((item) => {
              let data = {
                text: item.BCName,
                value: item.BCId,
              };
              serviceList.push(data);
            });
            this.serviceList = this.$commonMethod.deepClone(serviceList);

            var leavelOptions = [];
            this.settings[2].forEach((item) => {
              let data = {
                text: item.LeavelName,
                value: item.LeavelId,
              };
              leavelOptions.push(data);
            });
            this.leavelOptions = this.$commonMethod.deepClone(leavelOptions);

            var areaList = [];
            this.settings[3].forEach((item) => {
              let data = {
                text: item.RegionName,
                value: item.RegionId,
              };
              areaList.push(data);
            });
            this.areaList = this.$commonMethod.deepClone(areaList);

            var countryList = [];
            this.settings[4].forEach((item) => {
              let data = {
                text: item.CountryName + " , " + item.CountryName_en,
                value: item.CountryId,
              };
              countryList.push(data);
            });
            this.countryList = this.$commonMethod.deepClone(countryList);

            var cityList = [];
            this.settings[5].forEach((item) => {
              let data = {
                text: item.City_cn + " , " + item.City_en,
                value: item.Id,
              };
              cityList.push(data);
            });
            this.cityList = this.$commonMethod.deepClone(cityList);

            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    pickerShow(index, pickerName) {
      this[pickerName] = true;
      this.itemIndex = index;
    },
    onSelectCustomer(e) {
      this.form.Customer.text = e.text;
      this.form.Customer.value = e.value;
      this.form.Customer.CustomerNumber = e.CustomerNumber;
      this.$forceUpdate();
    },
    onSelectArea(e) {
      this.form.RegionName = e.text;
      this.form.RegionId = e.value;
      this.$forceUpdate();
    },
    onSelectCountry(e) {
      this.form.CountryName = e.text;
      this.form.CountryId = e.value;
      this.$forceUpdate();
    },
    onSelectCity(e) {
      this.form.CityName = e.text;
      this.form.CityId = e.value;
      this.$forceUpdate();
    },
    onSelectAw(e) {
      this.form.AWName = e.text;
      this.form.AWId = e.value;
      this.$forceUpdate();
    },
    onSelectBc(e) {
      this.form.BCName = e.text;
      this.form.BCId = e.value;
      this.$forceUpdate();
    },
    pickerConfirm(e, text, value) {
      this.form.QuotationList[this.itemIndex][text] = e.text;
      this.form.QuotationList[this.itemIndex][value] = e.value;
      this.showLevelPicker = false;
      this.showCurrencyPicker = false;
    },
    onShowEmit(emit) {
      this.$bus.$emit(emit, true);
    },
    onSubmit() {
      var param = {};
      var request = null;
      param = this.form;
      param.CustomerId = this.form.Customer.value;
      if (this.OASId) {
        param.OASId = this.OASId;
        request = this.$api.supplier.editOverseasAgentService(param);
      } else {
        request = this.$api.supplier.addOverseasAgentService(param);
      }
      this.$commonMethod.showLoading();
      request
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    getCurrencyList() {
      return new Promise((resolve) => {
        this.$api.financialManagement
          .getSystemAvailableCurrencyList()
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.CurrencySn,
                value: item.SCId,
              };
              result.push(data);
            });
            this.currencyList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    onCopy(e, text) {
      e.stopPropagation();
      this.$commonEnv.commonAction(this.$commonEnv.actionType.clickCopy, {
        text: text,
        alertText: this.$t.meta.copySuccess,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.overseasDetail {
  ::v-deep .number-label {
    line-height: 33px;
  }
  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #999 !important;
      -webkit-text-fill-color: #999 !important;
    }
  }
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .overseasDetail-radio {
    padding: 20px;
    border-bottom: 1px solid #ebedf0;
    .radio-label {
      color: #646566;
      margin-bottom: 20px;
      font-size: 14px;
    }
    .van-radio {
      margin-right: 20px;
      margin-bottom: 10px;
      font-size: 14px;
    }
  }
  .overseasDetail-checkbox {
    padding: 20px;
    border-bottom: 1px solid #ebedf0;
    .checkbox-label {
      color: #646566;
      margin-bottom: 20px;
      font-size: 14px;
    }
    .van-checkbox {
      margin-right: 20px;
      margin-bottom: 10px;
      font-size: 14px;
    }
  }
  .multi-table {
    .multi-table-header {
      padding: 10px 15px;
      .multi-table-title {
        font-size: 14px;
        color: #999;
        width: 70%;
        display: inline-block;
        vertical-align: middle;
      }
      .multi-table-btn {
        font-size: 20px;
        color: #000;
        width: 30%;
        display: inline-block;
        text-align: right;
        vertical-align: middle;
      }
    }
  }
}
</style>
